module.exports = __webpack_public_path__ + "img/mma-and-the-future.4967e2c2.jpg";